export enum WebUrlType {
  STATIC = 'Static',
  HOTEL = 'Hotel',
  HOTEL_CITY = 'HotelCity',
  HOTEL_REGION = 'HotelRegion',
  HOTEL_THEME = 'HotelTheme',
  HOTEL_CHAIN = 'HotelChain',
  TOUR = 'Tour',
  TOUR_REGION = 'TourRegion',
  TOUR_CATEGORY = 'TourCategory',
  TOUR_THEME = 'TourTheme',
  CRUISE = 'Cruise',
  CRUISE_REGION = 'CruiseRegion',
  CRUISE_CATEGORY = 'CruiseCategory',
  CRUISE_THEME = 'CruiseTheme',
  TOUR_TYPE = 'TourType',
  TOUR_CITY = 'TourCity',
  TOUR_COUNTRY = 'TourCountry',
  CRUISE_PORT = 'CruisePort',
  HOTEL_LANDING = 'HotelLanding',
  FLIGHT_LANDING = 'FlightLanding',
  FLIGHT_CITY_LANDING = 'FlightCityLanding',
  PAYMENT_OPTIONS = 'PaymentOptions',
  CAMPAIGN_DETAIL = 'CampaignDetail',
  CAMPAIGNS = 'Campaigns',
  PAYMENT_OPTIONS_DETAIL = 'PaymentOptionsDetail',
  PACKAGE_CITY = 'PackageCity',
  PACKAGE_REGION = 'PackageRegion',
  PACKAGE_THEME = 'PackageTheme',
}
